(function () {
  function init() {
    var section = document.querySelector('[data-hiw]');
    if (!section) return;

    var dots = section.querySelectorAll('[data-hiw-dot]');
    var steps = section.querySelectorAll('[data-hiw-step]');
    if (!dots.length || !steps.length) return;

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var idx = d.getAttribute('data-hiw-dot');
        var target = section.querySelector('[data-hiw-step="' + idx + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    function setActive(idx) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.classList.toggle('is-done', i < idx);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var idx = parseInt(e.target.getAttribute('data-hiw-step'), 10);
            setActive(idx);
          }
        });
      }, { threshold: 0.55 });
      steps.forEach(function (s) { io.observe(s); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
